export enum ChatMessageStatusEnum {
  Done = 'DONE',
  Pending = 'PENDING',
  Streaming = 'STREAMING',
}
